import {
  generateColorsCssVar,
  generateCommonCssVar
} from "./chunk-U6TI54F6.mjs";

// src/theme-provider/styles/global-variable.ts
import { css } from "@emotion/react";
var global_variable_default = ({
  colors,
  fontSizes,
  lineHeights,
  shadows,
  radius
}) => css`
  :root {
    ${generateColorsCssVar(colors)}
    ${generateCommonCssVar("fontSizes", fontSizes)}
    ${generateCommonCssVar("lineHeights", lineHeights)}
    ${generateCommonCssVar("shadows", shadows)}
    ${generateCommonCssVar("corner", radius)}
  }
`;

export {
  global_variable_default
};
